module.exports = __webpack_public_path__ + "img/main.3126e871.png";